import { formatGeDate, formatGeDateTime } from "./dates";

/**
 * Column definition for displaying date values with time information.
 *
 * The column type is "date", but it uses a DateTime formatter to include both date and time information for a more detailed view in the table.
 */
export const dateTimeColumnDef = {
  type: "date",
  valueGetter: (value) => value && new Date(value),
  valueFormatter: (value) => {
    return value && formatGeDateTime(value);
  },
};

/**
 * Column definition for displaying date values information.
 */
export const dateColumnDef = {
  type: "date",
  valueGetter: (value) => value && new Date(value),
  valueFormatter: (value) => {
    return value && formatGeDate(value);
  },
};
